import { useCallback, useState } from 'react';
import { useInterval } from 'react-use';
import ExportInputValuesStatus from 'store/transport-layer/document/export-input-values-jobs/ExportInputValuesStatus';

export default function useExportInputValuesProgressBarPercent({
  totalCount,
  completedCount,
  currentProgressCount,
  status,
}: {
  totalCount: number;
  completedCount: number;
  currentProgressCount: number;
  status?: ExportInputValuesStatus;
}) {
  // CSV 파일 생성 예상시간에 따라 70%부터 98%까지 프로그레스 바를 움직입니다. 1000건 이하일 때는 6초이며, 1000건 이상일 경우에는 전체 문서 양에 비례하여 시간 delay 를 늘립니다.
  const estimatedCSVCreationTime = totalCount > 1000 ? totalCount * 6 : 6000;
  const currentProgressPercent = Math.floor((currentProgressCount / totalCount) * 60 + 10) || 0;

  // 추출 준비: 10%, 입력값 추출: 60%, 파일 생성 30%로 progress bar 진행상황을 분배합니다.
  const [csvProgressPercent, setCSVProgressPercent] = useState(0);

  const isCreatingCSVFile =
    (totalCount === completedCount || status === 'DONE' || status === 'FAILED') && totalCount !== 0;

  useInterval(
    () => {
      setCSVProgressPercent(
        status === 'DONE' || status === 'FAILED' ? 30 : Math.min(csvProgressPercent + 1, 28)
      );
    },
    isCreatingCSVFile ? Math.floor(estimatedCSVCreationTime / 18) : null
  );

  const progressPercent = currentProgressPercent + csvProgressPercent;

  const resetEstimatedCSVCreationTime = useCallback(() => setCSVProgressPercent(0), []);

  return {
    progressPercent,
    resetEstimatedCSVCreationTime,
  };
}
